import { forwardRef } from "react";

import { observer } from "mobx-react";

import { BasicInput, BasicInputProps } from "../BasicInput";

export interface TextInputProps extends BasicInputProps {
  type: "text";
}

export const TextInput = observer(
  forwardRef<HTMLInputElement, TextInputProps>(function TextInput(props, ref) {
    return <BasicInput ref={ref} {...props} />;
  })
);
